/**
 * MUI Chip color for report workflow status labels.
 */
export function getReportStatusChipColor(status) {
    switch ((status || '').toLowerCase()) {
        case 'approved':
            return 'success';
        case 'awaiting review':
            return 'warning';
        case 'draft':
            return 'default';
        default:
            return 'default';
    }
}

export function isApprovedReportStatus(status) {
    return (status || '').toLowerCase() === 'approved';
}

/** Display label for status chips (approved FINTEL always reads as "Approved"). */
export function getReportStatusChipLabel(status) {
    if (isApprovedReportStatus(status)) {
        return 'Approved';
    }
    return status || 'Status';
}
